import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators } from '@angular/forms';
// import { UploadService } from '../../upload/upload.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { take } from 'rxjs/operators';
import { User } from '../../core/User';
import { AuthService } from '../../core/auth.service';
import { Item } from '../../models/Item'

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class EditUserComponent implements OnInit {

  userForm: FormGroup;
  doc_id: any;
  email = '';
  password = '';
  userName = '';
  role = '';
  client = '';
  errorMessage = '';
  error: { name: string, message: string } = { name: '', message: '' };

  userCollection: AngularFirestoreCollection<User>;
  users: Observable<User[]>;
  // surveyDoc: AngularFirestoreDocument<User>;
  formData: any;
  readonly path = 'users';

  userDocs: Observable<User[]>;


  itemCollection: AngularFirestoreCollection<Item>;
  items: Observable<Item[]>;
  readonly path2 = 'clients';
  itemDocs: Observable<Item[]>;
  itemData: any;
  topUp_value = 0;


  constructor(private router: Router, private _fb: FormBuilder, private afs: AngularFirestore, private route: ActivatedRoute, private authService: AuthService) { }

  getList() {

    this.userCollection = this.afs.collection('users', ref => ref.where('uid', '==', this.doc_id));

    this.users = this.userCollection.snapshotChanges().pipe(take(1)).map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as User;
        data.uid = a.payload.doc.id;
        return data;
      });
    });

    return this.users;
    // console.log(this.surveys);


  }

  getClients(): Observable<Item[]>{
    return this.afs.collection<Item>(this.path2)
    .snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Item;
        const id = a.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  ngOnInit() {
    if (this.authService.loggedInUserRole !== 'Admin') {
      this.router.navigate(['/home'])
    }

    this.itemDocs = this.getClients();

    this.route.params.subscribe(res => this.doc_id = res.id)
    this.authService.editUser_ID = this.doc_id;

    this.userForm = this._fb.group({
      'uid': ['', ],
      'userName': ['', Validators.required],
      'user_type': ['', Validators.required],
      'email': ['', Validators.required],
      'client': ['', Validators.required],
      'roles': ['', Validators.required],
      'monthly_quota':['', ],
      'used_quota':[''],
      'topUpCredits':[''],
    });


    

    this.userDocs = this.getList();

   

    this.getList().subscribe((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.formData = doc;
      });
      this.formData = this.formData;
      this.patchForm();
    })
  }

  patchForm() {
    this.userForm.patchValue({
      uid: this.formData.uid,
      client: this.formData.client,
      email: this.formData.email,
      roles: this.formData.roles,
      userName: this.formData.userName,
      user_type: this.formData.user_type,
      monthly_quota: this.formData.monthly_quota,
      used_quota: this.formData.used_quota,
      topUpCredits: this.formData.topUpCredits
    });

  }


  clearErrorMessage() {
    this.errorMessage = '';
    this.error = { name: '', message: '' };
  }


  onSignUp(): void {
    this.clearErrorMessage();
    
    this.authService.editUser_username= this.userName;
    this.authService.editUser_client= this.client;
    this.authService.editUser_role= this.role;
    this.authService.editUser_newEmail = this.email;
    
    this.authService.editUser();

    if (this.validateForm(this.email, this.password)) {
    
    }
  }

 
  validateForm(email: string, password: string): boolean {
    if (email.length === 0) {
      this.errorMessage = 'Please enter Email!'
      return false
    }

    if (password.length === 0) {
      this.errorMessage = 'Please enter Password!'
      return false
    }

    if (password.length < 6) {
      this.errorMessage = 'Password should be at least 6 characters!'
      return false
    }
    this.errorMessage = ''
    return true
  }

  isValidMailFormat(email: string) {
    const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    if ((email.length === 0) && (!EMAIL_REGEXP.test(email))) {
      return false;
    }

    return true;
  }

  onSubmit() {
    if (this.userForm.valid) {

      let topUpCredits:number = (this.formData.topUpCredits * 1) + (this.topUp_value * 1);


    const userData = this.userForm.value
    userData.email = this.formData.email;
    userData.topUpCredits = topUpCredits; 


    let x;
    x = {
      credits: this.topUp_value,
      created: new Date(),
    }
    
    if(userData.topUps) {
      userData.topUps.push(x);
    } else {
      userData.topUps = new Array();
      userData.topUps.push(x);
    }
    
    var setDoc = this.afs.collection('users').doc(this.userForm.value.uid).set(userData);
    alert("User has been updated");
    this.patchForm();
    this.router.navigateByUrl('/users/list');
  }
 
  }

  }


  


// WEBPACK FOOTER //
// ./src/app/auth/edit-user/edit-user.component.ts